import { Flex, Image, Text } from "rebass/styled-components";
import styled from "styled-components";
import { useEffect } from "react";

import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";

export const GenericNoClips = () => {
  const { track } = useAnalyticsContext();

  useEffect(() => {
    track("Component Viewed", {
      locationIdentifier: "generic_playlist_no_clips",
      location: "embeddable_playlist",
      featureGroup: "embeddable_playlist",
    });
  }, [track]);

  return (
    <Container>
      <Content>
        <StyledIcon
          src={`${process.env.REACT_APP_S3_CLIP_BUCKET}/static/web/iframe/exclamation.png`}
        />
        <Flex flexDirection="column" alignItems="center" style={{ gap: 8 }}>
          <ResponsiveHeading
            variant="headingMedium"
            color="ice"
            textAlign="center"
          >
            No clips found
          </ResponsiveHeading>
          <ResponsiveParagraph
            variant="paragraphMedium"
            color="chalk"
            textAlign="center"
          >
            This playlist doesn't exist or doesn't have any clips yet.
          </ResponsiveParagraph>
        </Flex>
      </Content>
    </Container>
  );
};

const Content = styled(Flex)`
  align-items: center;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  justify-content: center;
  margin: 0 60px;
  padding: 16px;
  position: relative;
  z-index: 2;

  @media (max-width: 480px) {
    gap: 4px;
    padding: 12px;
    margin: 0 20px;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    gap: 6px;
    padding: 14px;
    margin: 0 30px;
  }

  @media (min-width: 769px) {
    gap: 12px;
    padding: 20px;
    margin: 0 40px;
  }
`;

const StyledIcon = styled(Image)`
  height: 48px;
  width: 48px;

  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    width: 40px;
    height: 40px;
  }

  @media (min-width: 769px) {
    width: 64px;
    height: 64px;
  }
`;

const Container = styled.div`
  aspect-ratio: 16/9;
  background: linear-gradient(180deg, #0f1419 0%, #1a1f26 100%);
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #00000066;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const ResponsiveHeading = styled(Text)`
  @media (max-width: 480px) {
    font-size: 12px;
    line-height: 16px;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    font-size: 14px;
    line-height: 18px;
  }

  @media (min-width: 769px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

const ResponsiveParagraph = styled(Text)`
  @media (max-width: 480px) {
    font-size: 10px;
    line-height: 14px;
  }

  @media (min-width: 601px) and (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
  }

  @media (min-width: 481px) and (max-width: 600px) {
    font-size: 10px;
    line-height: 14px;
  }

  @media (min-width: 769px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
